import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, Loading, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ToastController } from 'ionic-angular';

import { Subscription } from 'rxjs';
import { Store } from "@ngrx/store";

import { AppStore } from './../../store/AppStore';
import { ResetPasswordAction } from '../../store/action/UserActions';

import { LoginPage } from '../login/login';

import { UserService } from './../../services/UserService';

import _ from 'lodash';

@IonicPage()
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {

  public form: FormGroup;
  public organizationLogo: string = null;
  public organizationName: string = null;
  public submitted: boolean = false;
  public isLoading: boolean = false;
  public loader: Loading;

  public users: any = [];

  private userStateSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public menuController: MenuController,
    private store: Store<AppStore>,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private userService: UserService) { }

  ngOnInit() {
    this.loadFormDefault();
    this.checkByEmail();
  }

  ionViewDidLoad() {
    this.menuController.enable(false);
    this.menuController.swipeEnable(false);
  }

  ionViewDidEnter() {
    this.userStateSubscription = this.store.select('userState').subscribe(userState => {
      this.isLoading = userState.loading;
      if (userState.resetPasswordError && !userState.loading) {
        this.presentToast('Endereço de e-mail não encontrado no sistema.');
      }
      if (userState.resetPasswordOk && !userState.loading) {

        let confirm = this.alertCtrl.create({
          title: 'Solicitação Enviada',
          message: 'Pedido de lembrete de senha realizado com sucesso. Verifique seu e-mail para prosseguir.',
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                this.navCtrl.setRoot(LoginPage);
              }
            }
          ]
        });
        confirm.present();
      }
      if (userState.organization != null) {
        this.organizationName = userState.organization.nomeFantasia;
        this.organizationLogo = userState.organization.logo;
      }
    });
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null) { this.userStateSubscription.unsubscribe() };
  }

  loadFormDefault(): void {
    this.form = this.formBuilder.group({
      'email': ['', Validators.required],
      'usuario': [null, Validators.required]
    });
  }

  checkByEmail = (function () {
    var timer = 0;
    return function () {

      window.clearTimeout(timer);
      this.users = [];
      this.form.controls.usuario.value = null;
      if (!this.form.controls.email.value.match(/\w+@\w+\.\w{2,}\.?\w{0,}/g)) return;

      timer = window.setTimeout(() => {
        this.findUserByEmail({ email: (this.form.controls.email.value || "") })
      }, 1000);
    }

  }())

  findUserByEmail(usuario: any): void {
    this.createLoader("Aguarde...", true);
    this.userService.findUserByEmail(usuario)
      .subscribe(data => {
        this.checkUser(data || []);
      });
    this.createLoader("", false);
  }

  checkUser(users: any): void {
    if (!users.length) {
      this.presentToast('Usuário ou senha inválidos');
      return;
    }
    if (users.length == 1) {
      this.users = [];
      this.form.controls.usuario.patchValue(_.assign({}, users[0], { senha: null }));
      return;
    }
    this.users = users;
  }

  resetPassword(): void {
    this.submitted = true;
    if (this.form.valid)
      this.store.dispatch(new ResetPasswordAction({
        email: this.form.controls.email.value,
        clientId: this.form.controls.usuario.value.clienteId
      }));
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  createLoader(message: string, create: boolean): void {
    if (!create) {
      this.loader.dismiss();
      this.loader = null;
      return;
    }

    if (this.loader == null) {
      this.loader = this.loadingCtrl.create({ content: message });
      this.loader.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts